var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartPie2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 5.78829C7.59833 6.16358 4.75 9.24914 4.75 13C4.75 17.004 7.99594 20.25 12 20.25C15.7508 20.25 18.8364 17.4016 19.2117 13.75H12C11.5858 13.75 11.25 13.4142 11.25 13V5.78829ZM3.25 13C3.25 8.16747 7.16751 4.24996 12 4.24996C12.4142 4.24996 12.75 4.58575 12.75 4.99996V12.25H20C20.4142 12.25 20.75 12.5858 20.75 13C20.75 17.8325 16.8325 21.75 12 21.75C7.16751 21.75 3.25 17.8325 3.25 13Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 4.67361V9.49996H20.3264C19.7633 7.11556 17.8844 5.23664 15.5 4.67361ZM14.998 3.06161C18.6183 3.51214 21.4878 6.38163 21.9384 10.0019C22.0066 10.55 21.5523 11 21 11H14.5C14.2239 11 14 10.7761 14 10.5V3.99996C14 3.44768 14.45 2.99341 14.998 3.06161Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPie2);
export default __webpack_public_path__ + "static/media/chart-pie-2.08e94f9cdadaeb8537ffdd3a3819a651.svg";
export { ForwardRef as ReactComponent };